export enum PrescriptionManagers {
  ELITE_GLOBAL = 1,
  LAD = 2,
  INTERNAL_MANAGEMENT = 3
}
